import SegmentBusinessRules from './SegmentBusinessRules';
export default SegmentBusinessRules;
